import { render } from "./WorkstationManagement.vue?vue&type=template&id=57724aa4&scoped=true"
import script from "./WorkstationManagement.vue?vue&type=script&lang=js"
export * from "./WorkstationManagement.vue?vue&type=script&lang=js"

import "./WorkstationManagement.vue?vue&type=style&index=0&id=57724aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57724aa4"]])

export default __exports__